export const nl = {
    languages: {
        cs: 'Tsjechisch',
        de: 'Duits',
        en: 'Engels',
        es: 'Spaans',
        fr: 'Frans',
        hr: 'Kroatisch',
        hu: 'Hongaars',
        it: 'Italiaans',
        nl: 'Nederlands',
        pl: 'Pools',
        ru: 'Russisch',
        sk: 'Slowaaks',
        tr: 'Turks',
        uk: 'Oekraïens',
        undefined: 'Geen ondertitels',
    },
    player: {
        content: {
            notFound: { title: 'Fout bij het laden van het media-element 😞' },
        },
        controls: {
            backwards: { title: '10s terug' },
            buffering: { title: 'Laden...' },
            captions: { title: 'Ondertitels' },
            forwards: { title: '10s vooruit' },
            fullscreen: { title: 'Volledig scherm' },
            pause: { title: 'Pauze' },
            play: { title: 'Afspelen' },
            playlist: { title: 'Afspeellijst' },
            volume: { title: 'Volume' },
        },
    },
};
